/**
 * Google Analytics custom event recording
 */
import {
  VerificationStep,
  ReduxState,
  DocUploadViewModel,
  VerificationResponse,
  WithCoreFields,
} from "../types/types";
import { logger } from "../utils/logger/logger";
import { VerificationStepsEnum } from "../types/runtimeTypes";

const events = {
  EVENT_CATEGORY: "Verification",
};

export enum isTestValues {
  TRUE = "true",
  FALSE = "false",
}

export const testRequestEmailDomains = ["sheerid.com"];

// GA admin config needs to correlate with these dimension index numbers:
export enum DimensionName {
  verificationId = "verificationId",
  programId = "programId",
  jslibVersionActual = "jslibVersionActual",
  testRequest = "testRequest",
  testMode = "testMode",
}

export const recordEvent = (step: VerificationStep, stepAction: string = "") => {
  window.gtag("event", events.EVENT_CATEGORY, {
    step,
    step_action: stepAction,
  });
};

export const recordViewModelChange = (oldState: ReduxState, newState: ReduxState) => {
  try {
    if (newState.verificationResponse.currentStep === VerificationStepsEnum.docUpload) {
      if (
        (oldState.viewModel as DocUploadViewModel).file1 === undefined &&
        (newState.viewModel as DocUploadViewModel).file1 !== undefined
      ) {
        recordEvent(VerificationStepsEnum.docUpload, "addFiles");
      }
    }
  } catch (e) {
    logger.warn("Failed addFiles event", e);
  }
};

export const recordVerificationResponse = (verificationResponse: VerificationResponse) => {
  try {
    const label =
      verificationResponse.errorIds && Array.isArray(verificationResponse.errorIds)
        ? verificationResponse.errorIds.sort().join(",")
        : undefined;
    recordEvent(verificationResponse.currentStep, label);
  } catch (e) {
    logger.warn("Failed recordVerificationResponse event", e);
  }
};

export const setDimension = (dimensionName: DimensionName, value: string) => {
  try {
    window.gtag("set", "user_properties", {
      [dimensionName]: value,
    });
  } catch (e) {
    logger.warn(`Failed to set ${dimensionName}`, e);
  }
};

export const setGaDimensionTestRequest = (viewModel: WithCoreFields) => {
  try {
    const { email } = viewModel;
    if (
      email &&
      testRequestEmailDomains.filter((domain) => email.indexOf(domain) > -1).length > 0
    ) {
      setDimension(DimensionName.testRequest, isTestValues.TRUE);
    }
  } catch (e) {
    logger.warn("Error setting testRequest dimension", e);
  }
};
